import type { useSingleton } from "@tippyjs/react";
import { useState } from "react";
import { MiniMapIcon } from "@/icons";
import { BottomBarItem } from "@/interface/BottomBar/BottomRightBar";
import { MiniMapWindow } from "@/interface/BottomBar/BottomRightBar/MiniMap/MiniMapWindow";
import { Tooltip } from "@/interface/ui/Tooltip";

type Props = {
    singletonTarget: ReturnType<typeof useSingleton>[1];
};

export const MiniMapButton = ({ singletonTarget }: Props) => {
    const [showMap, setShowMap] = useState(false);
    const handleClick = () => setShowMap((prevState) => !prevState);

    return (
        <>
            <Tooltip singleton={singletonTarget} content="Миникарта">
                <BottomBarItem onClick={handleClick} active={showMap}>
                    <MiniMapIcon />
                </BottomBarItem>
            </Tooltip>
            {showMap && <MiniMapWindow />}
        </>
    );
};
